<template>
  <div
    class="admin-page-content admin-form-page event-plan-form-page qms-form-page"
    :class="{ 'admin-form-page-dark event-plan-form-page-dark': isDarkMode }"
  >
    <div class="admin-form-shell event-plan-form-shell">
      <h1 class="admin-form-title event-plan-page-title">{{ title }}</h1>
      <div v-if="formType === 'update' && loading && !one" class="text-center py-4">
        <span class="spinner"></span>
      </div>
      <qms-form-box
        v-else-if="formType === 'new' || one"
        :form-type="formType"
        :initial="formInitial"
        :submitting="loading"
        @create="onCreate"
        @update="onUpdate"
      />
    </div>
    <b-modal
      v-model="showPfEcsRedirectModal"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Redirecting to PF/ECS portal"
    >
      <p class="mb-2">Your query has been saved successfully.</p>
      <p class="mb-0">
        You will be redirected to the PF/ECS portal in {{ pfEcsRedirectSeconds }}
        {{ pfEcsRedirectSeconds === 1 ? 'second' : 'seconds' }}.
      </p>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import QmsFormBox from '../../components/QmsFormBox.vue';

const PF_ECS_PORTAL_URL = 'https://pfesihelpdesk.aparajitha.com/home';
const PF_ECS_REDIRECT_DELAY_SECONDS = 5;

export default {
  name: 'QmsForm',
  components: { QmsFormBox },
  data() {
    return {
      formType: 'new',
      showPfEcsRedirectModal: false,
      pfEcsRedirectSeconds: PF_ECS_REDIRECT_DELAY_SECONDS,
      pfEcsRedirectTimer: null
    };
  },
  beforeUnmount() {
    this.clearPfEcsRedirectTimer();
  },
  metaInfo() {
    return {
      title: this.title
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'New query (QMS)' : 'Edit query (QMS)';
    },
    formInitial() {
      return this.one;
    },
    ...mapState('qms', ['loading', 'one']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapGetters('auth', ['isLoggedIn']),
    isQmsOtpGuestSession() {
      if (typeof sessionStorage === 'undefined') {
        return false;
      }
      return sessionStorage.getItem('qmsOtpVerified') === 'true' && !this.isLoggedIn();
    }
  },
  async mounted() {
    if (this.$route.name === 'qms-new' || this.$route.name === 'qms-new-direct') {
      this.formType = 'new';
      this.clearOne();
    } else {
      this.formType = 'update';
      await this.getOne({
        id: this.$route.params.id,
        router: this.$router
      });
    }
  },
  methods: {
    ...mapMutations('qms', ['clearOne']),
    ...mapActions('qms', ['getOne', 'postOne', 'patchOne', 'patchOneByRole']),
    isProvidentFundQuery(payload) {
      const selection = `${payload.department || ''} ${payload.queryType || ''}`.toLowerCase();
      return /provid(?:ent|ient)/.test(selection) && selection.includes('fund');
    },
    clearPfEcsRedirectTimer() {
      if (this.pfEcsRedirectTimer) {
        clearInterval(this.pfEcsRedirectTimer);
        this.pfEcsRedirectTimer = null;
      }
    },
    startPfEcsRedirect() {
      this.clearPfEcsRedirectTimer();
      this.pfEcsRedirectSeconds = PF_ECS_REDIRECT_DELAY_SECONDS;
      this.showPfEcsRedirectModal = true;
      this.pfEcsRedirectTimer = setInterval(() => {
        this.pfEcsRedirectSeconds -= 1;
        if (this.pfEcsRedirectSeconds <= 0) {
          this.clearPfEcsRedirectTimer();
          window.location.assign(PF_ECS_PORTAL_URL);
        }
      }, 1000);
    },
    async onCreate({ payload }) {
      const shouldRedirectToPfEcs = this.isProvidentFundQuery(payload);
      try {
        await this.postOne({
          payload,
          router: this.$router,
          redirectUrl: shouldRedirectToPfEcs ? '' : '/qms'
        });
        if (shouldRedirectToPfEcs) {
          this.startPfEcsRedirect();
        }
      } catch (_e) {
        // The store action displays the submission error.
      }
    },
    onUpdate({ payload }) {
      const patchAction = this.isQmsOtpGuestSession ? 'patchOne' : 'patchOneByRole';
      this[patchAction]({
        id: this.$route.params.id,
        payload,
        router: this.$router,
        redirectUrl: '/qms'
      });
    }
  }
};
</script>
